export const STATE_COLOR = {
  21: 'red',
  22: 'blue',
  23: 'green',
  25: 'black'
};
